var _style, _g, _g2, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandDeviceIdFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 579 789",
    style: {
      enableBackground: "new 0 0 579 789"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E8E7E8;}\r\n\t.st1{fill:#344457;}\r\n\t.st2{fill:#C7C7CF;}\r\n\t.st3{fill:#F9C7B4;}\r\n\t.st4{fill:#FCE0D5;}\r\n\t.st5{fill:#F3B4A1;}\r\n\t.st6{fill:#F5E6F1;}\r\n\t.st7{clip-path:url(#SVGID_00000144313310384575324790000014745708486298563734_);}\r\n\t.st8{clip-path:url(#SVGID_00000021810467685468846590000012931038705381333931_);fill:#FFFFFF;}\r\n\t\r\n\t\t.st9{clip-path:url(#SVGID_00000117649996766529589310000012275763948832761267_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st10{clip-path:url(#SVGID_00000085964679425071563080000004918942262277414277_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t\r\n\t\t.st11{clip-path:url(#SVGID_00000116950747546194095190000001885811974434057384_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st12{clip-path:url(#SVGID_00000110437839330202856680000010764238769990162338_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st13{clip-path:url(#SVGID_00000147220432990033830230000008624273826272723345_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st14{clip-path:url(#SVGID_00000070088627707563957140000008114533773352617904_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st15{clip-path:url(#SVGID_00000168080956432145915890000000994529944436099740_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st16{clip-path:url(#SVGID_00000004518457485939618680000003311489470810680473_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st17{clip-path:url(#SVGID_00000019646128716328431970000000473699256230291896_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st18{clip-path:url(#SVGID_00000175308726153935674580000005213986775663476401_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st19{clip-path:url(#SVGID_00000176750870362154798100000011475252786158680998_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st20{clip-path:url(#SVGID_00000121987513035889322490000017775297281872763307_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st21{clip-path:url(#SVGID_00000070118843067275092250000006146305333776081830_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st22{clip-path:url(#SVGID_00000007419832750363849190000014540098711359788200_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st23{clip-path:url(#SVGID_00000116944433627827809280000018374275690711778958_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st24{clip-path:url(#SVGID_00000071539201674500198130000005088834386188838286_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st25{clip-path:url(#SVGID_00000003787177538377393240000000178059037494757561_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st26{clip-path:url(#SVGID_00000047760408724571124410000017878947440371247801_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st27{clip-path:url(#SVGID_00000178895746128901682420000009126612655807452552_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st28{clip-path:url(#SVGID_00000093174748410652790060000013653188225835841922_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st29{clip-path:url(#SVGID_00000154388379353053160510000003740302324802456731_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st30{clip-path:url(#SVGID_00000088125693103159386180000005228182238613679762_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st31{clip-path:url(#SVGID_00000104706477470521807510000004301602057374149781_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st32{clip-path:url(#SVGID_00000036209145475563656710000008583389622498897792_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st33{clip-path:url(#SVGID_00000016050285327572429160000010326848064104786356_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st34{clip-path:url(#SVGID_00000160165986881022402810000004252197711140344491_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st35{clip-path:url(#SVGID_00000171716237486208749840000005674436982792685217_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st36{clip-path:url(#SVGID_00000016056919239791428990000011922526462009293466_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st37{clip-path:url(#SVGID_00000140718769438610781770000017873146188512555684_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st38{clip-path:url(#SVGID_00000057856621069775746090000009382487934707675567_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st39{clip-path:url(#SVGID_00000077303405347679430350000009884864679692120745_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st40{clip-path:url(#SVGID_00000106850593454020374190000007408248333122345646_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st41{clip-path:url(#SVGID_00000161597444139057685450000004847178671151129480_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st42{clip-path:url(#SVGID_00000081631849827138297640000013557031184247259320_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st43{clip-path:url(#SVGID_00000096759819493215469280000002324139610951168134_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st44{clip-path:url(#SVGID_00000043440770337056541290000000109712441088826026_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st45{clip-path:url(#SVGID_00000133492524349343987500000014524123675147030179_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st46{clip-path:url(#SVGID_00000141444212722389293810000004449853199333650342_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st47{clip-path:url(#SVGID_00000060026150173450035350000013645846821010815363_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st48{clip-path:url(#SVGID_00000106866095060677408670000011134054482214173330_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st49{clip-path:url(#SVGID_00000119115015929632946850000006733704756732050601_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st50{clip-path:url(#SVGID_00000149366017867616870280000012438361473770925993_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st51{clip-path:url(#SVGID_00000003088456194584141800000003253326533123870132_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st52{clip-path:url(#SVGID_00000149383953952042148450000017808856778475935386_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st53{clip-path:url(#SVGID_00000158743711915051369120000006494290699869733800_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st54{clip-path:url(#SVGID_00000083048758593125184290000005860056890609469081_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st55{clip-path:url(#SVGID_00000018923066399103838130000012065403761807216020_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st56{clip-path:url(#SVGID_00000155131287321012912780000013890779863815112348_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st57{clip-path:url(#SVGID_00000101084845486535530030000010504293912385311662_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st58{clip-path:url(#SVGID_00000173871662958195170180000006982301224159401388_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st59{clip-path:url(#SVGID_00000000198192432455291790000018443568052321715373_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st60{clip-path:url(#SVGID_00000075847510023993219550000004633631330026439563_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st61{clip-path:url(#SVGID_00000100373558739599222760000002108565089314955946_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st62{clip-path:url(#SVGID_00000009581771845596444480000016311058146928791461_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st63{clip-path:url(#SVGID_00000071521117279457472860000002328418852325766822_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st64{clip-path:url(#SVGID_00000120543942663225192990000002245726630387600024_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st65{clip-path:url(#SVGID_00000042008433216631975640000003626095295814402465_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st66{clip-path:url(#SVGID_00000144327016960704223910000013359191701325270161_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st67{clip-path:url(#SVGID_00000054232317602639147530000012859283760635599253_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st68{clip-path:url(#SVGID_00000154420617016948864620000000382017820356728192_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st69{clip-path:url(#SVGID_00000049934562960178044320000016291599369951403670_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st70{clip-path:url(#SVGID_00000004520957504878185100000008083239249480553123_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st71{clip-path:url(#SVGID_00000170273331263532308020000000615056299575567491_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st72{clip-path:url(#SVGID_00000096772659190005087700000011844261030778170805_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st73{clip-path:url(#SVGID_00000150818624923218498740000001855043344782862485_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st74{clip-path:url(#SVGID_00000004532818654369222480000008153712204445132206_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st75{clip-path:url(#SVGID_00000104695347369749425980000000787417840775621562_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st76{clip-path:url(#SVGID_00000086666468679206838970000010136730647201376161_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st77{clip-path:url(#SVGID_00000181770320705193442420000001104202719921321405_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st78{clip-path:url(#SVGID_00000150090046879832035510000006039641232294657960_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st79{clip-path:url(#SVGID_00000178184961305463273280000010869646047376288641_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st80{clip-path:url(#SVGID_00000047059020717613205540000004139304015332301485_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st81{clip-path:url(#SVGID_00000049933985965407729740000012896962099282265785_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st82{clip-path:url(#SVGID_00000129196642770655336880000005254343887218647960_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st83{clip-path:url(#SVGID_00000085250040618271800660000000560586244869613228_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st84{clip-path:url(#SVGID_00000129192308945330443570000000480300697994814118_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st85{clip-path:url(#SVGID_00000016036952044858000980000003867028233250671799_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st86{clip-path:url(#SVGID_00000026143013433051862870000007566307603726069169_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st87{clip-path:url(#SVGID_00000092438732304648862500000016881065244771295624_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st88{clip-path:url(#SVGID_00000060022767478486810470000000001925068415993781_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n\t\r\n\t\t.st89{clip-path:url(#SVGID_00000039097456057946766290000002860735163837825667_);fill-rule:evenodd;clip-rule:evenodd;fill:#727270;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone_3_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.7,585.8h-285c-11,0-20-9-20-20V20c0-11,9-20,20-20h285c11,0,20,9,20,20v545.8C384.7,576.8,375.8,585.8,364.7,585.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.7,549.7h-295c-3.3,0-6-2.7-6-6V42c0-3.3,2.7-6,6-6h294.9c3.3,0,6,2.7,6,6v501.7 C375.7,547.1,373,549.7,369.7,549.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.9,23.4h-61.4c-3,0-5.4-2.4-5.4-5.4l0,0c0-3,2.4-5.4,5.4-5.4h61.4c3,0,5.4,2.4,5.4,5.4l0,0 C258.3,21,255.9,23.4,252.9,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.9,18c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4s2.4,5.4,5.4,5.4S178.9,21,178.9,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.4,18c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4s2.4,5.4,5.4,5.4S276.4,21,276.4,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.3,576.8h-66.2c-1.7,0-3-1.3-3-3v-12c0-1.7,1.3-3,3-3h66.2c1.7,0,3,1.3,3,3v12 C258.3,575.4,257,576.8,255.3,576.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Hand_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_10_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.1,386.9c9.8-8.8,14.2-23.5,14.2-35.8c0-17.2-11.8-35.3-23.6-50.1v218.3c5.8-1.5,10.5-4.4,14.1-8.8 c9.3-11.4,8.2-29.2,6.2-40.6c9.6-10.1,13.7-19.4,13.7-30.5C102.8,421.5,94.9,404.6,78.1,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63,293.9l-2.2-0.4c-0.1,0-0.4-0.1-1-0.1v227c3.3,0,6.2-0.4,9-1.1V301c-1.5-1.8-2.9-3.6-4.3-5.3L63,293.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M487.3,684.3L267,716.2c0,0-40.6-58.2-58.2-74.1c-17.5-15.8-40.3-33.9-62.8-56.2h198.2 c22.4,0,40.6-18.2,40.6-40.6V226.9c0-17.7,10.9-35.6,28.3-35.6c21.1,0,23.5,27.2,23.5,39.2c0,77.1,37.4,162.9,37.4,192.8 c0,50.9-28.2,96.3-28.2,163.1C445.7,620.1,456.3,627.5,487.3,684.3z M68.7,376c11.9-6.1,17.5-22.2,17.5-35 c0-18.5-16.3-39.3-26.5-51.5V166.7c-10-4.3-18.2-6.7-24.1-6.7c-12.4,0-22.7,13.9-22.7,27.7c0,3,0.5,6.1,1.6,8.9 c9.3,24.4,29.6,41,43.2,54.4C28.7,259.1,0,279.7,0,310.2C0,329.9,20.6,354,20.6,354c-9.8,3.9-20.2,12.8-20.2,32.8 c0,14.5,5.4,30.5,20.5,44.1c-7.7,4-13.3,14.9-13.3,27.7c0,16.3,28.6,45.7,52.1,45.7c29.3,0,25.5-33.5,22.8-46.4 c10-9.9,14.2-18.1,14.2-28.5C96.7,410.5,86.9,393.4,68.7,376z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M438.3,261.6c-1.1-10.4-1.8-20.8-1.8-31c0-7.1-0.8-19.3-5.8-28.3c-8.9-2.6-19.4,1.9-18.9,13.6 C413.2,251,419.6,260.5,438.3,261.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.9,362.3c10.8,8.1,19.7-8.9,25-23c3.8-10.1-21.8-36-36.4-24.2c-5.5,4.5-10.9,20.1-7,27.4 C24.3,349.8,31.8,356.9,38.9,362.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.7,442.5c11.3,7,22.3-10,22.3-24.7c0-10.8-24.6-33.2-37.8-20.3c-5,4.9-8.8,20.6-4.4,27.4 C31.2,431.7,39.2,438,46.7,442.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.3,445.1C22.1,447.4,22.2,471,26,476c4,5.3,10.8,9.9,17.1,13c11.2,5.6,17.4-22.7,16.6-28.7 C52,457.9,44.4,452.2,36.3,445.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.5,162.2c3.7,1.1,7.8,2.6,12.2,4.5v122.7l-8.4-13.1c-2.5-3.9-3.8-8.5-3.8-13.1v-9 c3.3-1.2,6.7-2.3,10.1-3.3c-3.1-3.1-6.6-6.3-10.1-9.7C47.5,241.2,47.5,162.2,47.5,162.2z M215.1,648.4 c79.9-68.7,169.7-8.2,169.7-103.2c0,22.4-18.2,40.6-40.6,40.6H145.9c22.6,22.3,45.3,40.4,62.8,56.2 C210.6,643.7,212.7,645.9,215.1,648.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M262.9,789h285.8l-73.1-176.1c-5.2-12.4-19.4-18.3-31.8-13.2L244.9,682c-12.4,5.1-18.3,19.4-13.2,31.8 L262.9,789z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.2,789H579l-63.6-153.3c-5.2-12.4-19.4-18.3-31.8-13.2L237.7,724.1c-12.4,5.1-18.3,19.4-13.2,31.8L238.2,789z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.8,752.8c0.4,10.1-7.5,18.5-17.6,18.9s-18.6-7.5-19-17.5c-0.4-10.1,7.5-18.5,17.6-18.9 C271.9,734.8,280.4,742.7,280.8,752.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Vektor-Smartobjekt_00000042726780536211330870000015625336149856862399_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040575405861084823170000004917735150683305600_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000040575405861084823170000004917735150683305600_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000104703009002128891990000005919953636637858946_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050624880092970929230000012266166067271360141_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104703009002128891990000005919953636637858946_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000050624880092970929230000012266166067271360141_)",
      fill: "#FFFFFF"
    },
    d: "M106.1,468.6V116.3 c0-6.3,5.1-11.4,11.4-11.4h214.3c6.3,0,11.4,5.1,11.4,11.4v352.3c0,6.3-5.1,11.4-11.4,11.4H117.5 C111.2,480,106.1,474.9,106.1,468.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000055667554125186489490000002948744412255531158_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118395429232281991510000004194093399989353643_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055667554125186489490000002948744412255531158_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 142.9,
    style: {
      clipPath: "url(#SVGID_00000118395429232281991510000004194093399989353643_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 128.6,
    height: 118.1
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060007680094683445360000003952522542873213315_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021818667038105581940000006756417244699486615_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060007680094683445360000003952522542873213315_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000021818667038105581940000006756417244699486615_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: " M233.1,215.7h-6.7c-14.8,25.7-7.4,38.7-40.8,38.7v-51.8V202v-52.8c34.7,0,26,13,40.8,38.7h5.9c3.2-4.5,9-5.5,15.1-7.1v-0.2 c0-0.6,1-1.3,2.3-1.3c0.3,0,0.3,0.2,0.6,0.2c0.6-0.5,1.6-1,2.9-1.3c1.9-0.5,5.6-2.1,7.4-0.6c1.1,1.3-0.2,2.1-0.2,2.1 c9.8-1.8,22.6-4.3,26.6,9.3c8.3,0,4.7,31.9-9,35.6c-5.3,1.8-17.5-0.5-17.5-0.5c0.8,0.5,1.1,1.1,0.5,1.8 c-1.1,1.8-6.3-0.2-7.9-0.6c-1.4-0.3-2.4-0.8-3.2-1.3l-0.3,0.2c-1.1,0-2.3-0.6-2.3-1.3C241.9,221.3,236,219.9,233.1,215.7"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016057680039434845590000015817787716314930861_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098915891718828622880000015075869055609322397_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016057680039434845590000015817787716314930861_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 294.6,
    y: 285.8,
    style: {
      clipPath: "url(#SVGID_00000098915891718828622880000015075869055609322397_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 9.5,
    height: 169.5
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047050762516376266600000016828074293879748006_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142869450841120807650000000621639488088623521_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047050762516376266600000016828074293879748006_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 259.1,
    y: 285.8,
    style: {
      clipPath: "url(#SVGID_00000142869450841120807650000000621639488088623521_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 9.5,
    height: 169.5
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000056407308992514119540000011842347408890294709_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124847411747138954210000008879745888348563620_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056407308992514119540000011842347408890294709_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 285.8,
    style: {
      clipPath: "url(#SVGID_00000124847411747138954210000008879745888348563620_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 9.5,
    height: 169.5
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000927117932047789110000003325401397197948584_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134972235982347518380000010017452490664156063_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000927117932047789110000003325401397197948584_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 285.8,
    style: {
      clipPath: "url(#SVGID_00000134972235982347518380000010017452490664156063_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 9.5,
    height: 169.5
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000079465712151997599570000010371399512375641991_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044897474317006360490000001328599702848673955_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079465712151997599570000010371399512375641991_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 141,
    style: {
      clipPath: "url(#SVGID_00000044897474317006360490000001328599702848673955_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047023285993121723360000014795549024060936576_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070113417478767059070000005778570940245165984_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047023285993121723360000014795549024060936576_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 151.5,
    style: {
      clipPath: "url(#SVGID_00000070113417478767059070000005778570940245165984_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000009547654968335483080000000164203096770849187_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157278104998270931700000014646109142007921855_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009547654968335483080000000164203096770849187_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 147.4,
    style: {
      clipPath: "url(#SVGID_00000157278104998270931700000014646109142007921855_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000081646089998776148750000012107331532098258072_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085248813732019358280000012520093342126909056_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081646089998776148750000012107331532098258072_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 145.5,
    style: {
      clipPath: "url(#SVGID_00000085248813732019358280000012520093342126909056_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016042651699134993830000015668132577498065838_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167389846286140416660000017875968598828915619_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016042651699134993830000015668132577498065838_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 155.3,
    style: {
      clipPath: "url(#SVGID_00000167389846286140416660000017875968598828915619_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000012447817414868318180000005936032998659910276_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056414733985927663800000010593739365887274400_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012447817414868318180000005936032998659910276_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 159.1,
    style: {
      clipPath: "url(#SVGID_00000056414733985927663800000010593739365887274400_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119834291449516374880000002365720720982116789_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018230792485687833930000005431961460354810541_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119834291449516374880000002365720720982116789_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 166,
    style: {
      clipPath: "url(#SVGID_00000018230792485687833930000005431961460354810541_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000074410831679144165940000001627825871178980738_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124840916298308791560000015649132551296288690_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074410831679144165940000001627825871178980738_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 174.5,
    style: {
      clipPath: "url(#SVGID_00000124840916298308791560000015649132551296288690_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080188664451495881290000003277353855772559267_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060724683369499602830000009422844859718696614_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080188664451495881290000003277353855772559267_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 178.3,
    style: {
      clipPath: "url(#SVGID_00000060724683369499602830000009422844859718696614_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132778186131891577090000015479548954465183120_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002370565295032565400000008271070631896557704_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132778186131891577090000015479548954465183120_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 182.1,
    style: {
      clipPath: "url(#SVGID_00000002370565295032565400000008271070631896557704_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000100346621651265302360000014627342851988574142_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140701258131186635130000006256790050159700614_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100346621651265302360000014627342851988574142_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 186.9,
    style: {
      clipPath: "url(#SVGID_00000140701258131186635130000006256790050159700614_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096027213685814155110000000140787665321396633_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010271127791831393030000002439424992111890337_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096027213685814155110000000140787665321396633_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 188.8,
    style: {
      clipPath: "url(#SVGID_00000010271127791831393030000002439424992111890337_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000169538362141459090130000007702412935227495315_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068655493120243622580000004805293553073702552_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169538362141459090130000007702412935227495315_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 190.7,
    style: {
      clipPath: "url(#SVGID_00000068655493120243622580000004805293553073702552_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000059286783257133531870000009374750221064134530_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008860563671101319520000005197500002930983358_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059286783257133531870000009374750221064134530_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 194.5,
    style: {
      clipPath: "url(#SVGID_00000008860563671101319520000005197500002930983358_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000168839529097373849450000001161093950714648749_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086657020114762058240000012032252927831029924_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168839529097373849450000001161093950714648749_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 198.3,
    style: {
      clipPath: "url(#SVGID_00000086657020114762058240000012032252927831029924_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000056425704798427791170000011858930975958755724_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078016894436194257870000007258578776459533959_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056425704798427791170000011858930975958755724_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 218.3,
    style: {
      clipPath: "url(#SVGID_00000078016894436194257870000007258578776459533959_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083772261315385070390000014199847820160371388_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139261387208893372180000001993951024069594047_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083772261315385070390000014199847820160371388_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 222.1,
    style: {
      clipPath: "url(#SVGID_00000139261387208893372180000001993951024069594047_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176763272429955586390000011432834109606104504_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139977247804611387530000008079109463649594012_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176763272429955586390000011432834109606104504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 228.8,
    style: {
      clipPath: "url(#SVGID_00000139977247804611387530000008079109463649594012_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000011741522405323148810000002355827638566928829_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170268346161511839360000017779355679720878491_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011741522405323148810000002355827638566928829_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 232.6,
    style: {
      clipPath: "url(#SVGID_00000170268346161511839360000017779355679720878491_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000006705168573554955440000015001086631611992458_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057150421737170255090000010117515792752304273_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006705168573554955440000015001086631611992458_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 236.4,
    style: {
      clipPath: "url(#SVGID_00000057150421737170255090000010117515792752304273_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000099651133134499778340000004431710920268697504_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075145412301383248830000005576670837546605469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099651133134499778340000004431710920268697504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 240.2,
    style: {
      clipPath: "url(#SVGID_00000075145412301383248830000005576670837546605469_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044864921732969107590000000138875365984459905_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057863793329787135830000003247915217958033045_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044864921732969107590000000138875365984459905_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 242.1,
    style: {
      clipPath: "url(#SVGID_00000057863793329787135830000003247915217958033045_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000146482280687381119690000003633479197744687270_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178199901385285971060000014164350511348870063_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146482280687381119690000003633479197744687270_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 245.9,
    style: {
      clipPath: "url(#SVGID_00000178199901385285971060000014164350511348870063_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039823216048644058620000009566386167858359700_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044167894299036016790000007829973434328685482_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039823216048644058620000009566386167858359700_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 249.7,
    style: {
      clipPath: "url(#SVGID_00000044167894299036016790000007829973434328685482_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176752748201463506810000013184764260582633110_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178172786320511238740000011856378270490739863_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176752748201463506810000013184764260582633110_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 253.5,
    style: {
      clipPath: "url(#SVGID_00000178172786320511238740000011856378270490739863_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000059297372153791225060000014725867038346283960_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090285539160385488180000011087538026265234857_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059297372153791225060000014725867038346283960_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 255.4,
    style: {
      clipPath: "url(#SVGID_00000090285539160385488180000011087538026265234857_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000071554699715760857140000010234101242106925502_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153698188358042803090000010874660099403848102_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071554699715760857140000010234101242106925502_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 257.3,
    style: {
      clipPath: "url(#SVGID_00000153698188358042803090000010874660099403848102_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000134933194315494603050000017889014450109529531_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076603321199417781370000004603451675528621758_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134933194315494603050000017889014450109529531_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 261.2,
    style: {
      clipPath: "url(#SVGID_00000076603321199417781370000004603451675528621758_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127730940616319887410000015609102413840159403_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029762569562576973290000001476117648077310887_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127730940616319887410000015609102413840159403_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 263.1,
    style: {
      clipPath: "url(#SVGID_00000029762569562576973290000001476117648077310887_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000141450544751731488330000007106945548394143119_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011028230928580380760000016004232685225475474_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141450544751731488330000007106945548394143119_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 266.9,
    style: {
      clipPath: "url(#SVGID_00000011028230928580380760000016004232685225475474_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036965787518182677750000011013640616025732540_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034052181724691279070000000034418652783924131_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036965787518182677750000011013640616025732540_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 269.7,
    style: {
      clipPath: "url(#SVGID_00000034052181724691279070000000034418652783924131_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000072960174073560784860000002677879141902252953_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035513783359683720030000012888078696371737018_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072960174073560784860000002677879141902252953_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 273.5,
    style: {
      clipPath: "url(#SVGID_00000035513783359683720030000012888078696371737018_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000149339586041691496850000000218261505766077321_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049941555449048716620000003376355289226944645_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149339586041691496850000000218261505766077321_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 277.3,
    style: {
      clipPath: "url(#SVGID_00000049941555449048716620000003376355289226944645_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013176284074143527340000011449037117522052252_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119076658816983100760000009577320506457521060_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013176284074143527340000011449037117522052252_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 281.1,
    style: {
      clipPath: "url(#SVGID_00000119076658816983100760000009577320506457521060_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000138547638724999116880000013383745655618195891_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025424733302579544650000004457770860923783862_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138547638724999116880000013383745655618195891_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 300.2,
    style: {
      clipPath: "url(#SVGID_00000025424733302579544650000004457770860923783862_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000102540772724878497600000017946603394527404476_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098197428153169882920000005504388258762523788_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102540772724878497600000017946603394527404476_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 302.1,
    style: {
      clipPath: "url(#SVGID_00000098197428153169882920000005504388258762523788_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000043436650707727197790000002469738126839962790_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022546332559882929650000012162795887517920663_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043436650707727197790000002469738126839962790_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 304,
    style: {
      clipPath: "url(#SVGID_00000022546332559882929650000012162795887517920663_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085940665845291429980000002489112014549549206_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127736433597058893770000005627580880990707087_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085940665845291429980000002489112014549549206_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 305.9,
    style: {
      clipPath: "url(#SVGID_00000127736433597058893770000005627580880990707087_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000128447274309512561110000001790308571332113542_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134238876498815585690000008306153885889910925_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128447274309512561110000001790308571332113542_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 312.6,
    style: {
      clipPath: "url(#SVGID_00000134238876498815585690000008306153885889910925_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181079297339911140650000012463684763959311513_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106113967844370166630000014553633344001456046_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181079297339911140650000012463684763959311513_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 316.4,
    style: {
      clipPath: "url(#SVGID_00000106113967844370166630000014553633344001456046_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000089573000911216517940000013640490538772256169_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075140877852746899200000008990680714732420501_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089573000911216517940000013640490538772256169_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 320.2,
    style: {
      clipPath: "url(#SVGID_00000075140877852746899200000008990680714732420501_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000113317853392208285260000006075290655385962926_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047755045668029415800000011025760530985233599_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113317853392208285260000006075290655385962926_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 324,
    style: {
      clipPath: "url(#SVGID_00000047755045668029415800000011025760530985233599_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085228815163513074870000001821710271321333171_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183950454627041346980000012252826187069682585_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085228815163513074870000001821710271321333171_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 328.8,
    style: {
      clipPath: "url(#SVGID_00000183950454627041346980000012252826187069682585_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031899290745743686830000013214388221408266883_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158006569513378469610000010592368633117964974_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031899290745743686830000013214388221408266883_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 332.6,
    style: {
      clipPath: "url(#SVGID_00000158006569513378469610000010592368633117964974_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000151537628951886512270000000525496447679170985_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034774628056416521440000011658601692184822714_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151537628951886512270000000525496447679170985_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 340.2,
    style: {
      clipPath: "url(#SVGID_00000034774628056416521440000011658601692184822714_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108990295513687512680000011613660871699390620_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119804688770701821550000012685255966544039615_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108990295513687512680000011613660871699390620_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 344,
    style: {
      clipPath: "url(#SVGID_00000119804688770701821550000012685255966544039615_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000102545296353533715610000000089363543789181614_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041269898009372082850000014473423610199144613_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102545296353533715610000000089363543789181614_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 347.8,
    style: {
      clipPath: "url(#SVGID_00000041269898009372082850000014473423610199144613_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041279767963157769030000004875373781715988878_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014613245429327349830000002814148930458231718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041279767963157769030000004875373781715988878_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 351.6,
    style: {
      clipPath: "url(#SVGID_00000014613245429327349830000002814148930458231718_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155142061425142937440000001448080468205243068_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002376381833452175590000013750415076923673985_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155142061425142937440000001448080468205243068_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 355.4,
    style: {
      clipPath: "url(#SVGID_00000002376381833452175590000013750415076923673985_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000068655672607463305480000003429309474142518443_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029750910155486008830000016419838963469879424_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068655672607463305480000003429309474142518443_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 357.3,
    style: {
      clipPath: "url(#SVGID_00000029750910155486008830000016419838963469879424_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000081613247852303611760000011184206009240929159_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098907812721056093930000017187164096479280776_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081613247852303611760000011184206009240929159_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 363,
    style: {
      clipPath: "url(#SVGID_00000098907812721056093930000017187164096479280776_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062874868103187786160000008212034169757724583_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151531470474368740930000001428161535002055588_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062874868103187786160000008212034169757724583_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 364.9,
    style: {
      clipPath: "url(#SVGID_00000151531470474368740930000001428161535002055588_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000138543032296887692950000008454259201748354440_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121999681419570900710000014967695921022819750_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138543032296887692950000008454259201748354440_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 366.8,
    style: {
      clipPath: "url(#SVGID_00000121999681419570900710000014967695921022819750_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070808825038354078280000002673368486981102268_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171714208634348429080000003898032081682962584_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070808825038354078280000002673368486981102268_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 369.7,
    style: {
      clipPath: "url(#SVGID_00000171714208634348429080000003898032081682962584_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000101825677072489026660000000930074122357772673_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178184300941854028150000016187067727854421385_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101825677072489026660000000930074122357772673_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 369.7,
    style: {
      clipPath: "url(#SVGID_00000178184300941854028150000016187067727854421385_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181788577706724417540000005283239314418334111_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118391697686313655220000015892778093964549253_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181788577706724417540000005283239314418334111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 368.8,
    style: {
      clipPath: "url(#SVGID_00000118391697686313655220000015892778093964549253_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000093136275563201675290000012542967128151438734_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009563213304194810650000000704730846771971487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093136275563201675290000012542967128151438734_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 374.5,
    style: {
      clipPath: "url(#SVGID_00000009563213304194810650000000704730846771971487_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116917577983408049210000014820756732469466253_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027573593292674705460000009175429295357215645_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116917577983408049210000014820756732469466253_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 378.3,
    style: {
      clipPath: "url(#SVGID_00000027573593292674705460000009175429295357215645_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000076590994691765571640000004895454748127553466_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052088954426673889610000004919574137351172745_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076590994691765571640000004895454748127553466_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 382.1,
    style: {
      clipPath: "url(#SVGID_00000052088954426673889610000004919574137351172745_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000923125562219652400000005382647629051780778_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062183259843481356080000012143878827688668589_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000923125562219652400000005382647629051780778_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 393.5,
    style: {
      clipPath: "url(#SVGID_00000062183259843481356080000012143878827688668589_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000106119051580168329750000014160968988033532315_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156568217075783904530000001250207440994772632_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106119051580168329750000014160968988033532315_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 394.5,
    style: {
      clipPath: "url(#SVGID_00000156568217075783904530000001250207440994772632_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000117643681524138999940000000966334804110770879_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031906847134584388350000016947919318830469800_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117643681524138999940000000966334804110770879_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 451.6,
    style: {
      clipPath: "url(#SVGID_00000031906847134584388350000016947919318830469800_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000927807690821293750000001645160809623340445_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091017129658196205720000018210715919402604958_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000927807690821293750000001645160809623340445_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 447.8,
    style: {
      clipPath: "url(#SVGID_00000091017129658196205720000018210715919402604958_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000101081150356970243280000009682089174920553351_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005944967579646218630000003738391066041708956_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101081150356970243280000009682089174920553351_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 443,
    style: {
      clipPath: "url(#SVGID_00000005944967579646218630000003738391066041708956_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041977810779621992780000010575934282770219684_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085234801121509002280000013881245475303966880_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041977810779621992780000010575934282770219684_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 441.1,
    style: {
      clipPath: "url(#SVGID_00000085234801121509002280000013881245475303966880_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047044575507155487740000001609481683240380337_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124851775362897999670000001281516779399117202_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047044575507155487740000001609481683240380337_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 439.2,
    style: {
      clipPath: "url(#SVGID_00000124851775362897999670000001281516779399117202_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142876228435375138170000015040798504446188459_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025436660996211318990000000201296034401282728_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142876228435375138170000015040798504446188459_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 433.5,
    style: {
      clipPath: "url(#SVGID_00000025436660996211318990000000201296034401282728_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005235032719933976710000000342898901734869392_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122694948917184090760000005751425345054173593_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005235032719933976710000000342898901734869392_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 431.6,
    style: {
      clipPath: "url(#SVGID_00000122694948917184090760000005751425345054173593_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181792658334976102430000005674591351782342301_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181074352099413213610000004748876870291953295_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181792658334976102430000005674591351782342301_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 427.8,
    style: {
      clipPath: "url(#SVGID_00000181074352099413213610000004748876870291953295_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000053538614022557767680000002503691916207499172_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011717384390618814280000007104344280532597680_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053538614022557767680000002503691916207499172_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 424,
    style: {
      clipPath: "url(#SVGID_00000011717384390618814280000007104344280532597680_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000126283857935221048320000016196902744578155421_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044868947391020560610000003094097754772536462_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126283857935221048320000016196902744578155421_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 416.4,
    style: {
      clipPath: "url(#SVGID_00000044868947391020560610000003094097754772536462_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000014592914702918814820000002887290173647070346_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103967304755436442450000006517135167612617100_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014592914702918814820000002887290173647070346_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 411.6,
    style: {
      clipPath: "url(#SVGID_00000103967304755436442450000006517135167612617100_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152259781471550089950000013299831241235528834_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024680138573593703470000017523077433399652738_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152259781471550089950000013299831241235528834_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 407.8,
    style: {
      clipPath: "url(#SVGID_00000024680138573593703470000017523077433399652738_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000072251834646771041170000018404021720082648750_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116197930098429249410000002011332410743762566_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072251834646771041170000018404021720082648750_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 404,
    style: {
      clipPath: "url(#SVGID_00000116197930098429249410000002011332410743762566_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003069520797814320230000012881355578959112361_",
    x: 106.1,
    y: 104.8,
    width: 237.1,
    height: 375.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172409274473413385210000005885651806483287452_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003069520797814320230000012881355578959112361_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 400.2,
    style: {
      clipPath: "url(#SVGID_00000172409274473413385210000005885651806483287452_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727270"
    },
    width: 28.6,
    height: 1.9
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandDeviceIdFront);
export default __webpack_public_path__ + "static/media/hand-device-id-front.450c6be3b476d8115c282a66f45eed45.svg";
export { ForwardRef as ReactComponent };